//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get all study routes by study
 * @param studyId (optional) 
 */
export function getAll(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StudyRouteDto[]> {
    let url_ = getBaseUrl() + "/api/studyRoutes";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAll,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "studyId": studyId !== undefined && studyId !== null ? "" + studyId : "",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAll(_response);
    });
}

function processGetAll(response: AxiosResponse): Promise<Types.StudyRouteDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyRouteDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyRouteDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyRouteDto[]>(null as any);
}

/**
 * Create study route
 */
export function createStudyRoute(dto: Types.CreateStudyRouteDto, config?: AxiosRequestConfig | undefined): Promise<Types.StudyRouteDto> {
    let url_ = getBaseUrl() + "/api/studyRoutes";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateStudyRoute,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateStudyRoute(_response);
    });
}

function processCreateStudyRoute(response: AxiosResponse): Promise<Types.StudyRouteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyRouteDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyRouteDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyRouteDto>(null as any);
}

/**
 * Get study route
 */
export function getStudyRouteById(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.StudyRouteDto> {
    let url_ = getBaseUrl() + "/api/studyRoutes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyRouteById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyRouteById(_response);
    });
}

function processGetStudyRouteById(response: AxiosResponse): Promise<Types.StudyRouteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyRouteDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyRouteDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyRouteDto>(null as any);
}

/**
 * Re-open missed and finished forms (pipeline steps) for specific patient.
 * @param patientId Related patient id
 * @param dto DTO with new pipeline steps
 */
export function openRouteProgressStepManually(patientId: string, dto: Types.UpdatePatientRouteProgressDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studyRoutes/{patientId}";
    if (patientId === undefined || patientId === null)
      throw new Error("The parameter 'patientId' must be defined.");
    url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigOpenRouteProgressStepManually,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processOpenRouteProgressStepManually(_response);
    });
}

function processOpenRouteProgressStepManually(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add new checkpoint to study route
 * @param studyRouteId ID of the StudyRoute where the new checkpoint will be added
 * @param dto DTO with new checkpoint
 */
export function addCheckpointToStudyRoute(studyRouteId: string, dto: Types.AddCheckpointDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studyRoutes/checkPoints/{studyRouteId}";
    if (studyRouteId === undefined || studyRouteId === null)
      throw new Error("The parameter 'studyRouteId' must be defined.");
    url_ = url_.replace("{studyRouteId}", encodeURIComponent("" + studyRouteId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddCheckpointToStudyRoute,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddCheckpointToStudyRoute(_response);
    });
}

function processAddCheckpointToStudyRoute(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add new form config to study route
 * @param dto The form config dto to add
 * @param studyRouteId (optional) StudyRouteId to add form config
 * @param checkpointName (optional) The name of the Checkpoint where to add the form config
 */
export function addFormConfigToCheckpoint(dto: Types.AddFormConfigToCheckpointDto, studyRouteId?: string | undefined, checkpointName?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studyRoutes/formConfig?";
    if (studyRouteId === null)
        throw new Error("The parameter 'studyRouteId' cannot be null.");
    else if (studyRouteId !== undefined)
        url_ += "studyRouteId=" + encodeURIComponent("" + studyRouteId) + "&";
    if (checkpointName === null)
        throw new Error("The parameter 'checkpointName' cannot be null.");
    else if (checkpointName !== undefined)
        url_ += "checkpointName=" + encodeURIComponent("" + checkpointName) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddFormConfigToCheckpoint,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddFormConfigToCheckpoint(_response);
    });
}

function processAddFormConfigToCheckpoint(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get the route progress of the patient by id
 * @param patientId Id of the patient whose route progress is requested
 */
export function getPatientRouteProgress(patientId: string, config?: AxiosRequestConfig | undefined): Promise<Types.RouteProgressDto> {
    let url_ = getBaseUrl() + "/api/studyRoutes/RouteProgress/OfPatient?";
      if (patientId === undefined || patientId === null)
        throw new Error("The parameter 'patientId' must be defined and cannot be null.");
      else
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientRouteProgress,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientRouteProgress(_response);
    });
}

function processGetPatientRouteProgress(response: AxiosResponse): Promise<Types.RouteProgressDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.RouteProgressDto.fromJS(resultData200);
        return Promise.resolve<Types.RouteProgressDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RouteProgressDto>(null as any);
}
let _requestConfigGetAll: Partial<AxiosRequestConfig> | null;
export function getGetAllRequestConfig() {
  return _requestConfigGetAll;
}
export function setGetAllRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAll = value;
}
export function patchGetAllRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAll = patch(_requestConfigGetAll ?? {});
}

let _requestConfigCreateStudyRoute: Partial<AxiosRequestConfig> | null;
export function getCreateStudyRouteRequestConfig() {
  return _requestConfigCreateStudyRoute;
}
export function setCreateStudyRouteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyRoute = value;
}
export function patchCreateStudyRouteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyRoute = patch(_requestConfigCreateStudyRoute ?? {});
}

let _requestConfigGetStudyRouteById: Partial<AxiosRequestConfig> | null;
export function getGetStudyRouteByIdRequestConfig() {
  return _requestConfigGetStudyRouteById;
}
export function setGetStudyRouteByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyRouteById = value;
}
export function patchGetStudyRouteByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyRouteById = patch(_requestConfigGetStudyRouteById ?? {});
}

let _requestConfigOpenRouteProgressStepManually: Partial<AxiosRequestConfig> | null;
export function getOpenRouteProgressStepManuallyRequestConfig() {
  return _requestConfigOpenRouteProgressStepManually;
}
export function setOpenRouteProgressStepManuallyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigOpenRouteProgressStepManually = value;
}
export function patchOpenRouteProgressStepManuallyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigOpenRouteProgressStepManually = patch(_requestConfigOpenRouteProgressStepManually ?? {});
}

let _requestConfigAddCheckpointToStudyRoute: Partial<AxiosRequestConfig> | null;
export function getAddCheckpointToStudyRouteRequestConfig() {
  return _requestConfigAddCheckpointToStudyRoute;
}
export function setAddCheckpointToStudyRouteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddCheckpointToStudyRoute = value;
}
export function patchAddCheckpointToStudyRouteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddCheckpointToStudyRoute = patch(_requestConfigAddCheckpointToStudyRoute ?? {});
}

let _requestConfigAddFormConfigToCheckpoint: Partial<AxiosRequestConfig> | null;
export function getAddFormConfigToCheckpointRequestConfig() {
  return _requestConfigAddFormConfigToCheckpoint;
}
export function setAddFormConfigToCheckpointRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddFormConfigToCheckpoint = value;
}
export function patchAddFormConfigToCheckpointRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddFormConfigToCheckpoint = patch(_requestConfigAddFormConfigToCheckpoint ?? {});
}

let _requestConfigGetPatientRouteProgress: Partial<AxiosRequestConfig> | null;
export function getGetPatientRouteProgressRequestConfig() {
  return _requestConfigGetPatientRouteProgress;
}
export function setGetPatientRouteProgressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientRouteProgress = value;
}
export function patchGetPatientRouteProgressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientRouteProgress = patch(_requestConfigGetPatientRouteProgress ?? {});
}